export default function LoadingPage() {
  return <div className={"app white-app-bg"}></div>;
}
